import React, { useContext } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { isMobile } from 'react-device-detect'

import {
  ScreenContainer,
  MainHeader,
  MainContentContainer,
  MainSubHeader,
  VerticalDivider,
} from '../Shared/SharedStyledComponents'
import { TopColorBar } from '../../SelectSubscriptionPlanScreen/SelectSubscriptionPlanScreen.jsx'
import BackButton from '../../shared/BackButton'
import NavigationBar from '../../NavigationBar/NavigationBar'
import { DailyBalanceTile, MealsListTile } from './DietMainScreenStyles'
import { DietStandardButton } from '../Shared/SharedStyledComponents'
import DailyBalance from './subComponents/DailyBalance'
import MealsList from './subComponents/MealsList'
import MobileTopNavigationBar from '../../MobileTopNavigationBar/MobileTopNavigationBarContainer'
import DemoModeAnnouncement from '../../DemoModeAnnouncement/DemoModeAnnouncement.jsx'
import AppContext from '../../../context/appContext'
import Navigation from '../../Challenges/components/Navigation/Navigation'

import {
  MealDetails,
  MealDetailsTileContainer,
  CartButton,
  CartButtonContainer,
  CartButtonText,
} from '../MealDetailsScreen/MealDetailsScreenStyles'
import { usePromiseTracker } from 'react-promise-tracker'
import Loader from '../../Loader/Loader'
import SwitchDietIcon from '../../../assets/REDESIGN_Assets/Diet/change-diet-icon.svg'

import GenericBackgroundLayer from '../../../GenericComponents/GenericBackgroundLayer'
import GenericIcon from '../../../GenericComponents/GenericIcon'
import GenericRow from '../../../GenericComponents/GenericRow'
import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import GenericLogo from '../../../GenericComponents/GenericLogo'
import GenericMainCard from '../../../GenericComponents/GenericMainCard'
import GenericColumn from '../../../GenericComponents/GenericColumn'
import GenericMobileTopNavigation from '../../../GenericComponents/GenericMobileTopNavigation'
import CartIcon from '../../../assets/REDESIGN_Assets/Diet/diet-cart-icon.svg'

interface DietMainScreenProps {
  userDailyBalance: any
  date: any
  nextDateBalance: any
  prevDateBalance: any
  meals: any
  sniadanie: any
  IIsniadanie: any
  obiad: any
  przekaska: any
  kolacja: any
  calorieGoal: any
  fatGoal: any
  carbsGoal: any
  proteinGoal: any
  calorieCurrent: any
  todayDate: any
  chosenDate: any
  removeMeal: any
  diet: any
  changeDiet: any
  userPlanData: any
  isDemoAccount: boolean
  challengeMode: boolean
}

const DietMainScreen: React.FC<DietMainScreenProps> = ({
  userDailyBalance,
  date,
  nextDateBalance,
  prevDateBalance,
  meals,
  sniadanie,
  IIsniadanie,
  obiad,
  przekaska,
  kolacja,
  calorieGoal,
  fatGoal,
  carbsGoal,
  proteinGoal,
  calorieCurrent,
  todayDate,
  chosenDate,
  removeMeal,
  diet,
  changeDiet,
  userPlanData,
  isDemoAccount,
  challengeMode
}) => {
  const location = useLocation()
  const pageData = location.state
  let history = useHistory()
  const { promiseInProgress } = usePromiseTracker()
  const appContext = useContext(AppContext)

  const goToShoppingList = () => {
    history.push({
      pathname: `/dieta/${chosenDate ? chosenDate : todayDate}/lista-zakupow/`,
      state: { chosenDate: chosenDate },
      challengeMode: challengeMode
    })
  }
  const goBackToMainpage = () => {
    history.push('/trening')
  }

  const goBackToChallenges = () => {
    history.push('/wyzwania')
  }

  return (
    <GenericBackgroundLayer
      fDir={'column'}
      justify={'flex-start'}
      align={'center'}
      className={`${appContext.appState.theme == 'light' ? 'light' : 'standard diet-screen'
        }`}
    >
      {challengeMode ? <Navigation /> : <NavigationBar isPlayerView={false} backButtonAction={goBackToMainpage} />}
      {isMobile && (
        <GenericMobileTopNavigation
          isPlayerView={false}
          dietCartClick={() => goToShoppingList()}
          handleClick={() => challengeMode ? goBackToChallenges() : goBackToMainpage()}
        />
      )}
      <GenericMainCard
        flexDir={'column'}
        className="standard"
        width={isMobile ? '95%' : '60%'}
        margin={isMobile ? '0 auto' : '5% auto 0 auto'}
      >
        <GenericRow
          align={isMobile ? 'center' : 'baseline'}
          margin={isMobile ? '0' : '0 0 0 8%'}
          width={'75%'}
          justify={isMobile ? 'center' : 'space-between'}
          flexDir={isMobile ? 'column' : 'row'}
        >
          <GenericTextSpan
            fSize={isMobile ? '2rem' : '1.4rem'}
            margin={'0 0 5% 0'}
          >
            {diet && diet.diet_name}
          </GenericTextSpan>

          {!isMobile && (
            <GenericIcon
              className={'button-style '}
              onClick={() => goToShoppingList()}
              src={CartIcon}
              margin={'0 0 0 8%'}
              width={'1.5vw'}
              height={'1.5vw'}
            />
          )}

          <GenericRow
            onClick={changeDiet}
            className={'pointer'}
            width={isMobile ? '50%' : '25%'}
            justify={isMobile ? 'center' : 'flex-end'}
          >
            <GenericTextSpan fSize={isMobile ? '1.4rem' : '1rem'}>
              Zmień dietę
            </GenericTextSpan>
            <GenericIcon
              margin={'0 0 0 6%'}
              width={isMobile ? '3vw' : '1vw'}
              height={isMobile ? '3vw' : '1vw'}
              src={SwitchDietIcon}
            ></GenericIcon>
          </GenericRow>
        </GenericRow>

        <GenericRow
          wrap={isMobile ? 'wrap' : 'unset'}
          align={'flex-start'}
          width={'100%'}
        >
          <GenericColumn width={isMobile ? '100%' : '50%'}>
            <DailyBalanceTile>
              <DailyBalance
                nextDateBalance={nextDateBalance}
                userDailyBalance={userDailyBalance}
                date={date}
                prevDateBalance={prevDateBalance}
                calorieGoal={calorieGoal}
                fatGoal={fatGoal}
                carbsGoal={carbsGoal}
                proteinGoal={proteinGoal}
                calorieCurrent={calorieCurrent}
                userPlanData={userPlanData}
              />
            </DailyBalanceTile>
          </GenericColumn>
          <GenericColumn width={isMobile ? '100%' : '50%'}>
            <MealsListTile>
              <MealsList
                userDailyBalance={userDailyBalance}
                meals={meals}
                sniadanie={sniadanie}
                IIsniadanie={IIsniadanie}
                obiad={obiad}
                przekaska={przekaska}
                kolacja={kolacja}
                todayDate={todayDate}
                chosenDate={chosenDate}
                removeMeal={removeMeal}
                challengeMode={challengeMode}
              />
            </MealsListTile>
          </GenericColumn>
        </GenericRow>
      </GenericMainCard>
    </GenericBackgroundLayer>

    // <ScreenContainer>
    //   <TopColorBar relative>
    //     <BackButton place={'Diety'} specialLocation={'/trening'} />
    //   </TopColorBar>
    //   {/* <MobileTopNavigationBar /> */}
    //   <NavigationBar />
    //   <MainHeader>Diety</MainHeader>
    //   <MainSubHeader>{diet && diet.diet_name}</MainSubHeader>
    //   <DietStandardButton
    //     margin={'10px auto'}
    //     color={'white'}
    //     backgroundColor="blueviolet"
    //     onClick={changeDiet}
    //   >
    //     Zmień dietę
    //   </DietStandardButton>
    //   <MainContentContainer
    //     padding={isMobile ? '2vh 1vw 4vh 1vw' : '5vh 3vw'}
    //     marginTop={isMobile ? '1vh' : '5vh'}
    //     justify={'center'}
    //   >
    //     <DailyBalanceTile>
    //       <DailyBalance
    //         nextDateBalance={nextDateBalance}
    //         userDailyBalance={userDailyBalance}
    //         date={date}
    //         prevDateBalance={prevDateBalance}
    //         calorieGoal={calorieGoal}
    //         fatGoal={fatGoal}
    //         carbsGoal={carbsGoal}
    //         proteinGoal={proteinGoal}
    //         calorieCurrent={calorieCurrent}
    //         userPlanData={userPlanData}
    //       />
    //     </DailyBalanceTile>
    //     <VerticalDivider display={isMobile ? 'none' : 'unset'} />
    //     <MealsListTile>
    //       <MealsList
    //         userDailyBalance={userDailyBalance}
    //         meals={meals}
    //         sniadanie={sniadanie}
    //         IIsniadanie={IIsniadanie}
    //         obiad={obiad}
    //         przekaska={przekaska}
    //         kolacja={kolacja}
    //         todayDate={todayDate}
    //         chosenDate={chosenDate}
    //         removeMeal={removeMeal}
    //       />
    //     </MealsListTile>
    //     <CartButtonContainer onClick={goToShoppingList}>
    //       <CartButtonText>{!isMobile ? 'Koszyk' : ''}</CartButtonText>

    //       <CartButton
    //       // className={shouldAnimate && 'animate'}
    //       // className="animate"
    //       // hasCartSomeItems={dietAppStore.hasOwnProperty('diet')}
    //       ></CartButton>
    //     </CartButtonContainer>
    //     {isDemoAccount && <DemoModeAnnouncement />}
    //   </MainContentContainer>
    //   {promiseInProgress && <Loader />}
    // </ScreenContainer>
  )
}

export default DietMainScreen
